






















import { Vue, Component, Watch } from 'vue-property-decorator'
import BigCard from '@/components/dashboardComp/DashboardCard.vue'
import { mapGetters, mapState } from 'vuex'
import { functionsForDashboard } from '@/types/DashboardConcours'

@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA']),
        ...mapState('auth', ['user', 'authUser']),
        ...mapGetters('dashboardConcours', ['loading_dashboard', 'dashboard_concours_informations'])
    },
    components: {
        BigCard
    }
})
export default class Dashboard extends Vue {
    dashboardElements!: string[]
    dashboardReady = false
    reload = false
    count_passage_abilities = 0


    @Watch('dashboard_concours_informations')
    loadCompteurs () {
        this.dashboardReady = false
        this.initDashboard()
    }

    initDashboard () {
        this.dashboardElements = functionsForDashboard.dashboardFiltered(functionsForDashboard.dashboardElements)
        this.dashboardReady = true
    }

    mounted () {
        this.$store.dispatch('dashboardConcours/getDashboardInformations')
    }
}
